import { Timeline } from "antd"
import BaseSection from "../../../../components/elements/BaseSection"
import { ReactNode, useMemo } from "react"
import { ReactComponent as DONE } from "../../../../assets/ApprovaICON.svg"
import { ReactComponent as EDIT } from "../../../../assets/EditICON.svg"
import { ReactComponent as MONEY } from "../../../../assets/Cash.svg"
import { MajorOrderActionCode } from "../../../../api/constants"
import dayjs from "dayjs"
import BaseSectionHeadline from "../../../../components/elements/BaseSectionHeadline"

type MajorOrderDetailHistoryType = {
    history: {
        actionCode: string // TODO
        timestamp: Date
        message?: string
        user: {
            first_name: string
            last_name: string
        }
    }[]
}

export default function MajorOrderDetailHistory(props: MajorOrderDetailHistoryType) {
    const timeSteps = useMemo<{ children: ReactNode }[]>(
        () =>
            props.history?.reverse()?.map((item) => ({
                color:
                    item.actionCode === MajorOrderActionCode.FINAL_BILLED
                        ? "green"
                        : item.actionCode === MajorOrderActionCode.CANCELED
                        ? "red"
                        : "blue",
                dot:
                    item.actionCode === MajorOrderActionCode.FINAL_BILLED ? (
                        <DONE className="w-6 h-6" />
                    ) : item.actionCode === MajorOrderActionCode.EDIT ? (
                        <EDIT className="w-6 h-6" />
                    ) : item.actionCode === MajorOrderActionCode.BILLED ? (
                        <MONEY className="w-6 h-6" />
                    ) : undefined,
                children: (
                    <div className="flex flex-col gap-1">
                        <h5 className="text-sm">
                            <span className={`font-semibold ${item.actionCode === MajorOrderActionCode.CANCELED && "text-error"}`}>
                                {item.actionCode}
                            </span>
                            {item.user && (
                                <>
                                    {" "}
                                    von{" "}
                                    <span className="font-semibold">
                                        {item.user?.first_name} {item.user?.last_name}
                                    </span>
                                </>
                            )}
                        </h5>
                        {item.message && <p className="text-xs text-gray-400">{item.message}</p>}
                        <p className="text-xs text-gray-400">
                            am {dayjs(item.timestamp).format("DD.MM.YYYY")} um {dayjs(item.timestamp).format("HH:mm")} Uhr
                        </p>
                    </div>
                ),
            })) || [],
        [props.history]
    )

    return (
        <BaseSection>
            <BaseSectionHeadline label="History" />
            <Timeline items={timeSteps} />
        </BaseSection>
    )
}
